(function () {
  var ENDPOINT = "https://api.shilajit.work/api/meta/funnel-shadow";
  var SENT = {};
  var ANON_KEY = "_hng_meta_anon_id";
  var ANON_TS_KEY = "_hng_meta_anon_id_ts";
  var ANON_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  // P1 browser<->CAPI dedup: events for which we ALSO fire a content-less Meta
  // pixel track sharing this event's event_id. Meta dedups it against the CAPI
  // event (same event_id) and merges the in-context _fbp (which the pixel sets
  // reliably) with the server identity. ONLY events the server CAPI also sends
  // are listed, so every browser track has a CAPI twin to dedup against (no
  // standalone browser volume). PageView (no CAPI counterpart) and
  // InitiateCheckout (its CAPI twin is the customer_event source with a
  // DIFFERENT event_id, so a browser IC track would not dedup and would
  // double-count) are intentionally ABSENT.
  var DEDUP_TRACK_EVENTS = { ViewContent: 1, ViewCart: 1, Search: 1 };
  // CEO 2026-10-31 (Meta DPA spent $0.10-0.90 a day of $15): the browser ViewContent is the FIRST event of the
  // event_id pair, Meta keeps it, so with {} the catalog audience got no product. It now carries content_ids ONLY for
  // a variant of Meta catalog 4018791215046833, the same list as the server (meta_capi_sender
  // DEFAULT_ALLOWED_CATALOG_VARIANT_IDS) and the checkout pixel; every other event and variant stays content-less.
  var HNG_CATALOG_VARIANT_IDS = {
    "51585936331": true,
    "51586292491": true,
    "38061600309420": true,
    "52752620618091": true,
    "41172122763436": true,
    "37119392481452": true,
    "53246740660587": true,
    "30147102638124": true,
    // CEO 2026-11-01: every active product and bundle of the main store (not the cup or the bag)
    "54243428401515": true, "54242900115819": true, "54243427909995": true, "54242909520235": true,
    "54290767937899": true, "54242913616235": true, "51663800074603": true, "51663800107371": true,
    "51663799812459": true, "51663799845227": true, "51663800009067": true, "51663800041835": true,
    "51663799877995": true, "51663799910763": true, "8904423505964": true, "52754343559531": true,
    "51907003810155": true, "52754343428459": true
  };

  function catalogData(payload) {
    var ids = payload.event_name === "ViewContent" && payload.content_ids ? payload.content_ids : [];
    var id = ids.length === 1 ? String(ids[0]) : "";
    return HNG_CATALOG_VARIANT_IDS[id] === true ? { content_type: "product", content_ids: [id] } : {};
  }

  function cookie(name) {
    try {
      var parts = ("; " + document.cookie).split("; " + name + "=");
      return parts.length === 2 ? decodeURIComponent(parts.pop().split(";").shift()) : "";
    } catch (e) {
      return "";
    }
  }

  function looksLikeFbc(value) {
    return /^fb\.1\.\d+\.[^\s.][^\s]*$/.test(String(value || ""));
  }

  function looksLikeFbp(value) {
    return /^fb\.1\.\d+\.\d+$/.test(String(value || ""));
  }

  function looksLikeHngAnon(value) {
    return /^hnganon_[a-f0-9]{32}$/.test(String(value || ""));
  }

  function randomHex32() {
    var bytes = [];
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var arr = new Uint8Array(16);
        window.crypto.getRandomValues(arr);
        for (var i = 0; i < arr.length; i += 1) bytes.push(arr[i]);
      }
    } catch (e) {}
    while (bytes.length < 16) bytes.push(Math.floor(Math.random() * 256));
    return bytes
      .map(function (b) {
        return ("0" + b.toString(16)).slice(-2);
      })
      .join("");
  }

  function readAttributionData() {
    try {
      var stored = window.localStorage && window.localStorage.getItem("_attribution_data");
      if (stored) return JSON.parse(stored);
    } catch (e) {}
    try {
      var raw = cookie("_attribution_data");
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return {};
  }

  function rawParam(name) {
    try {
      var search = window.location && window.location.search ? window.location.search : "";
      var re = new RegExp("(?:^|[?&])" + name + "=([^&]+)");
      var match = search.match(re);
      return match ? match[1] : "";
    } catch (e) {
      return "";
    }
  }

  function validRawFbclid(value) {
    return /^[^\s.][^\s]*$/.test(String(value || ""));
  }

  function normalizeFbc(value) {
    if (!looksLikeFbc(value)) return "";
    var clean = String(value).trim();
    var parts = clean.split(".");
    var ts = Number(parts[2]);
    if (!ts || ts < 1500000000) return "";
    if (ts < 1000000000000) {
      parts[2] = String(Math.floor(ts * 1000));
      return parts.join(".");
    }
    return clean;
  }

  function metaFbc(data, eventTime) {
    var direct = cookie("_fbc") || (data && data.fbc);
    var normalized = normalizeFbc(direct);
    if (normalized) return normalized;
    var fbclid = rawParam("fbclid") || (data && data.fbclid) || "";
    if (!validRawFbclid(fbclid)) return "";
    var ts = Number(data && data.captured_at);
    if (!ts || ts < 1500000000) return "";
    if (ts < 1000000000000) ts = ts * 1000;
    return "fb.1." + Math.floor(ts) + "." + fbclid;
  }

  function metaFbp(data) {
    var direct = cookie("_fbp") || (data && data.fbp);
    return looksLikeFbp(direct) ? String(direct).trim() : "";
  }

  function privacyAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return true;
      if (
        typeof privacy.analyticsProcessingAllowed === "function" &&
        typeof privacy.marketingAllowed === "function"
      ) {
        return privacy.analyticsProcessingAllowed() || privacy.marketingAllowed();
      }
    } catch (e) {}
    return true;
  }

  function metaAnonId() {
    if (!privacyAllowed()) return "";
    try {
      var now = Date.now();
      var stored = window.localStorage && window.localStorage.getItem(ANON_KEY);
      var storedAt = Number(window.localStorage && window.localStorage.getItem(ANON_TS_KEY));
      if (looksLikeHngAnon(stored) && storedAt && now - storedAt < ANON_TTL_MS) {
        return stored;
      }
      var fresh = "hnganon_" + randomHex32();
      if (!looksLikeHngAnon(fresh)) return "";
      if (window.localStorage) {
        window.localStorage.setItem(ANON_KEY, fresh);
        window.localStorage.setItem(ANON_TS_KEY, String(now));
      }
      return fresh;
    } catch (e) {
      return "";
    }
  }

  function hashish(input) {
    var raw = String(input || "");
    var h = 0;
    for (var i = 0; i < raw.length; i += 1) {
      h = (Math.imul(31, h) + raw.charCodeAt(i)) | 0;
    }
    return Math.abs(h).toString(36);
  }

  function postBeacon(body) {
    if (navigator.sendBeacon) {
      var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
      if (navigator.sendBeacon(ENDPOINT, blob)) return;
    }
    if (window.fetch) {
      fetch(ENDPOINT, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: body,
      }).catch(function () {});
    }
  }

  // The site-wide base Meta pixel loads fbevents.js asynchronously, so on a
  // fresh page load the _fbp cookie is usually not set yet when a page-load
  // event (e.g. ViewContent) fires. Send immediately (never lose the event),
  // then if fbp was missing poll briefly and re-send the SAME event_id once the
  // cookie lands. The shadow ingest merges on conflict (best-identity-wins) so
  // this only backfills fbp; the same event_id is deduped downstream so it can
  // never double-count. Consent is re-checked every tick because Shopify
  // privacy state can hydrate, or the visitor can revoke, during the wait.
  function backfillFbp(payload) {
    var tries = 0;
    var iv = setInterval(function () {
      if (!privacyAllowed()) {
        clearInterval(iv);
        return;
      }
      tries += 1;
      var fbp = metaFbp(readAttributionData());
      if (fbp) {
        clearInterval(iv);
        payload.fbp = fbp;
        try { postBeacon(JSON.stringify(payload)); } catch (e) {}
      } else if (tries >= 20) {
        clearInterval(iv);
      }
    }, 150);
  }

  function send(payload) {
    try {
      if (!privacyAllowed()) return;
      var attribution = readAttributionData();
      payload.event_time = payload.event_time || Math.floor(Date.now() / 1000);
      payload.fbp = metaFbp(attribution);
      payload.fbc = metaFbc(attribution, payload.event_time);
      var anonId = metaAnonId();
      if (anonId) payload.external_id_raw = anonId;
      payload.event_source_url =
        window.location && window.location.href
          ? window.location.href
          : "https://naturalshilajit.com/";
      payload.source = payload.source || "theme";
      if (SENT[payload.event_id]) return;
      SENT[payload.event_id] = true;
      postBeacon(JSON.stringify(payload));
      if (!payload.fbp) backfillFbp(payload);
      // P1 dedup track. Content-less except a ViewContent of a catalog variant
      // (catalogData: one allowlisted variant id, content_type product, nothing
      // else), so no foreign id can reach the Meta catalog. fbevents queues the
      // call until it loads and fires it WITH the _fbp cookie; Meta dedups it
      // against the same-event_id CAPI event and merges identity.
      try {
        if (window.fbq && DEDUP_TRACK_EVENTS[payload.event_name]) {
          window.fbq("track", payload.event_name, catalogData(payload), { eventID: payload.event_id });
        }
      } catch (e) {}
    } catch (e) {}
  }

  // ── PDP selection resolver ───────────────────────────────────────────────
  // The Horizon CRO theme (live 2026-07-22) adds to cart through window.NSCart,
  // so the product page carries NO form[action*="/cart/add"]. The old id/price
  // probes below it returned nothing and ViewContent stopped firing entirely.
  //
  // Wrong identity is worse than a missing event: the server recomputes Meta
  // custom_data.value from item_price * quantity and only rejects non-positive
  // values, so a bad id or a bad unit ships silently. Therefore the resolver
  // returns variant AND price as ONE atomic pair from ONE source, and
  // contentPayload() calls it exactly once. Every branch that cannot establish
  // that pair with confidence returns null and emits no event at all.
  //
  // UNITS: pdp-data carries price in DOLLARS (49), ShopifyAnalytics in CENTS
  // (4900). The contract of currentPrice()/contentPayload() is DOLLARS.

  function pdpSizes() {
    try {
      if (!document.getElementById) return null;
      var el = document.getElementById("pdp-data");
      if (!el) return null;
      var data = JSON.parse(el.textContent || "{}");
      var sizes = data && data.sizes;
      if (!sizes || !sizes.length) return null;
      var initial = typeof data.initialSize === "number" ? data.initialSize : 0;
      return { sizes: sizes, initial: initial };
    } catch (e) {
      return null;
    }
  }

  var SIZE_CONTROL_SELECTOR = ".rb-size[data-sizeidx]";

  // activeSizeIndex() return values:
  //   >= 0  exactly one size is marked active -- trustworthy
  //   -1    nothing marked active (not hydrated yet, or no selector)
  //   -2    controls disagree -- ambiguous, must NOT be guessed
  var SIZE_NONE = -1;
  var SIZE_AMBIGUOUS = -2;

  function activeSizeIndex() {
    // The theme stamps every size control with its OWN index into sizes
    // (data-sizeidx), so we never infer from DOM ordinal position -- the page
    // renders duplicate desktop/mobile size groups and ordinals would drift.
    // Duplicated groups also mean several controls can claim to be active; if
    // they name different sizes we refuse rather than take the first one.
    var found = SIZE_NONE;
    try {
      if (!document.querySelectorAll) return SIZE_NONE;
      var btns = document.querySelectorAll(SIZE_CONTROL_SELECTOR);
      for (var i = 0; i < btns.length; i += 1) {
        var btn = btns[i];
        var on =
          btn.getAttribute("aria-checked") === "true" ||
          /(^|\s)is-active(\s|$)/.test(btn.className || "");
        if (!on) continue;
        var idx = parseInt(btn.getAttribute("data-sizeidx"), 10);
        if (isNaN(idx) || idx < 0) continue;
        if (found === SIZE_NONE) {
          found = idx;
        } else if (found !== idx) {
          return SIZE_AMBIGUOUS;
        }
      }
    } catch (e) {
      return SIZE_NONE;
    }
    return found;
  }

  function sizeEntry(entry) {
    if (!entry || !entry.variantId) return null;
    var price =
      typeof entry.price === "number" && entry.price > 0
        ? Number(entry.price.toFixed(2))
        : null;
    return { variantId: String(entry.variantId), price: price };
  }

  function urlVariantId() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var variant = params.get("variant");
      if (variant) return String(variant);
    } catch (e) {}
    return "";
  }

  function legacyFormSelection() {
    // Legacy layouts only -- the live Horizon theme carries no cart-add form.
    //
    // We take the identity from the form but deliberately NOT the price. `id`
    // and `ns_meta_variant_price_cents` are two independently mutable controls
    // and nothing in the form keys one to the other, so a variant switch can
    // advance the id while the price is still the server-rendered one for the
    // previous variant. The pair cannot be PROVEN atomic, therefore we do not
    // claim it: ViewContent without a value is useful, ViewContent carrying
    // another variant's value corrupts the value-optimisation signal we are
    // trying to restore. Known remaining limit, unchanged from the original
    // code: on a page whose first cart form belongs to a quick-add or upsell
    // block, this reports that block's variant.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || typeof form.querySelector !== "function") return null;
    var idEl = form.querySelector('input[name="id"], select[name="id"]');
    var variantId = idEl && idEl.value ? String(idEl.value) : "";
    if (!variantId) return null;
    return { variantId: variantId, price: null };
  }

  function sizeByVariantId(pdp, variantId) {
    if (!variantId) return null;
    for (var i = 0; i < pdp.sizes.length; i += 1) {
      var entry = sizeEntry(pdp.sizes[i]);
      if (entry && entry.variantId === variantId) return entry;
    }
    return null;
  }

  function resolveSelection() {
    var pdp = pdpSizes();
    var explicit = urlVariantId();

    if (pdp) {
      // A URL variant is the shopper's explicit request for THIS page load, and
      // the beacon fires once, on load. So when the URL names a size this page
      // actually offers, it wins: the active control may still be showing the
      // pre-hydration default, and refusing there would lose the event for good.
      var wanted = sizeByVariantId(pdp, explicit);
      if (wanted) return wanted;
      // A URL naming a variant this page does not offer is stale or hand-edited.
      if (explicit) return null;

      var idx = activeSizeIndex();
      if (idx === SIZE_AMBIGUOUS) return null;
      if (idx >= 0 && idx < pdp.sizes.length) {
        var active = sizeEntry(pdp.sizes[idx]);
        if (active) return active;
      }
      var fallback = pdp.initial >= 0 && pdp.initial < pdp.sizes.length ? pdp.initial : 0;
      return sizeEntry(pdp.sizes[fallback]);
    }

    // No pdp-data: legacy layouts. The cart form is the only source that carries
    // an id and its price together, so it is the only one trusted for both.
    var legacy = legacyFormSelection();
    if (explicit) {
      if (legacy) return legacy.variantId === explicit ? legacy : null;
      // Nothing on the page can price this id atomically. Emit the identity
      // without a value rather than borrow a price that may belong elsewhere:
      // ViewContent without value is useful, ViewContent with a wrong value is not.
      return { variantId: explicit, price: null };
    }
    return legacy;
  }

  function contentPayload() {
    // Resolved ONCE, so content_ids and value always describe the same variant.
    var selection = resolveSelection();
    if (!selection || !selection.variantId) return null;
    var variant = selection.variantId;
    var payload = {
      content_ids: [variant],
      contents: [{ id: variant, quantity: 1 }],
      currency: "USD",
      variant_id: variant,
    };
    if (selection.price && selection.price > 0) {
      payload.value = selection.price;
      payload.contents[0].item_price = selection.price;
    }
    return payload;
  }

  function trackPageView() {
    send({
      event_name: "PageView",
      event_id: "ns-theme-pv-" + Date.now() + "-" + hashish(window.location.pathname),
    });
  }

  function trackViewContent() {
    if (!/\/products\//.test(window.location.pathname || "")) return;
    var content = contentPayload();
    if (!content) return;
    content.event_name = "ViewContent";
    content.event_id = "ns-theme-vc-" + Date.now() + "-" + content.variant_id;
    send(content);
  }

  function trackSearch() {
    if (!/\/search/.test(window.location.pathname || "")) return;
    send({
      event_name: "Search",
      event_id: "ns-theme-search-" + Date.now() + "-" + hashish(window.location.search),
    });
  }

  function trackViewCart() {
    if (!/\/cart\/?$/.test(window.location.pathname || "")) return;
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (resp) {
        return resp.json();
      })
      .then(function (cart) {
        var contents = [];
        var ids = [];
        var items = cart && cart.items ? cart.items : [];
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i];
          var id = item && item.variant_id ? String(item.variant_id) : "";
          var price = item && item.final_price ? Number((item.final_price / 100).toFixed(2)) : 0;
          var quantity = item && item.quantity ? Number(item.quantity) : 1;
          if (!id || price <= 0 || quantity <= 0) continue;
          ids.push(id);
          contents.push({ id: id, quantity: quantity, item_price: price });
        }
        var value = cart && cart.total_price ? Number((cart.total_price / 100).toFixed(2)) : 0;
        if (!ids.length || value <= 0) return;
        send({
          event_name: "ViewCart",
          event_id: "ns-theme-viewcart-" + hashish(cart.token || Date.now()),
          content_ids: ids,
          contents: contents,
          value: value,
          currency: "USD",
        });
      })
      .catch(function () {});
  }

  function bindCheckoutClickFallback() {
    document.addEventListener(
      "click",
      function (event) {
        var target = event.target && event.target.closest
          ? event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]')
          : null;
        if (!target) return;
        fetch("/cart.js", { credentials: "same-origin" })
          .then(function (resp) {
            return resp.json();
          })
          .then(function (cart) {
            var contents = [];
            var ids = [];
            var items = cart && cart.items ? cart.items : [];
            for (var i = 0; i < items.length; i += 1) {
              var item = items[i];
              var id = item && item.variant_id ? String(item.variant_id) : "";
              var price = item && item.final_price ? Number((item.final_price / 100).toFixed(2)) : 0;
              var quantity = item && item.quantity ? Number(item.quantity) : 1;
              if (!id || price <= 0 || quantity <= 0) continue;
              ids.push(id);
              contents.push({ id: id, quantity: quantity, item_price: price });
            }
            var value = cart && cart.total_price ? Number((cart.total_price / 100).toFixed(2)) : 0;
            if (!ids.length || value <= 0) return;
            send({
              event_name: "InitiateCheckout",
              source: "theme",
              event_id: "ns-theme-ic-" + hashish(cart.token || Date.now()),
              content_ids: ids,
              contents: contents,
              value: value,
              currency: "USD",
            });
          })
          .catch(function () {});
      },
      true
    );
  }

  trackPageView();
  trackViewContent();
  trackSearch();
  trackViewCart();
  bindCheckoutClickFallback();
})();
